import React, {forwardRef} from 'react'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

// Props:
//  • buttonSx: additional sx for the IconButton
//  • iconSx:   additional sx for the CloseIcon
//  • iconProps: any other CloseIcon props (e.g. color, fontSize...)
//  • ...props: any other IconButton props (e.g. onClick, aria-label...)
const CloseButton = forwardRef(({
  iconSx = {}, 
  buttonSx = {}, 
  iconProps = {}, 
  ...props 
}, ref) => {
  return (
    <IconButton
      ref={ref}
      size="large"
      sx={{
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
        ...buttonSx,
      }}
      {...props}
    >
      <CloseIcon
        sx={{
          fontSize: 24,            
          color: 'disabled',
          ...iconSx,
        }}
        {...iconProps}
      />
    </IconButton>
  )
})


export default CloseButton